import { Modal, ModalHeading, ModalFooter } from "@biteship/atom";

export default function ModalUploadStatus(props) {
  const goToOverview = () => {
    window.location.assign("/overview");
  };

  const footerButtons = () => [{ title: "Lanjut Ke Beranda", onClick: () => goToOverview() }];

  return (
    <Modal size="md" show={props.show}>
      <ModalHeading title="Status Penambahan Rates" onClose={goToOverview} />
      {props.rates.map((rate, idx) => (
        <div
          className={`${idx < props.rates.length - 1 && "border-b-2"} flex justify-between p-2`}
          key={idx}
        >
          <div>Rate {idx + 1}</div>
          <div className={`${rate.uploadStatus === "success" ? "text-success" : "text-danger"}`}>
            {rate.uploadStatus === "success" ? "Berhasil" : "Gagal"} ditambahkan
          </div>
        </div>
      ))}
      <ModalFooter secondaryButtons={footerButtons()} />
    </Modal>
  );
}
